import React from "react";

export const SidePanel: React.FC = () => {
  return (
    <div className="sticky top-6 h-[calc(100vh-3rem)] overflow-hidden rounded-xl">
      <img
        src="/gamification-side.png"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
    </div>
  );
};
